import DashboardLayoutHeader from 'components/layout/dashboardLayoutHeader/DashboardLayoutHeader';
import { Outlet } from 'react-router-dom';
import { useAtom } from 'jotai';
import { ChatState } from 'stores/atoms/chatState';
import { NavbarState } from 'stores/atoms/navbarState';
import WsChatSidebar from 'pages/ws/components/chatSidebar/WsChatSidebar';
import WsLayoutNavbar from 'pages/ws/components/layout/layoutNavbar/WsLayoutNavbar';

import type { JSX } from 'react';

/**
 * 設定画面のレイアウト定義
 */
export default function WsLayout(): JSX.Element {
  /* ----------------------------------------------------------------------- */
  /* 変数定義 */
  /* ----------------------------------------------------------------------- */
  const [navbarState, setNavbarState] = useAtom(NavbarState);
  const [chatState, setChatState] = useAtom(ChatState);

  /* ----------------------------------------------------------------------- */
  /* イベントハンドラ関数定義 */
  /* ----------------------------------------------------------------------- */
  /**
   * スマートフォンレイアウト時のナビゲーションバーを閉じます
   */
  const onSpNavbarClose = () => {
    if (navbarState.open) {
      setNavbarState({ open: false });
    }
  };

  /* ----------------------------------------------------------------------- */
  /* JSX */
  /* ----------------------------------------------------------------------- */
  return (
    <main>
      <DashboardLayoutHeader />
      <WsLayoutNavbar />
      <div
        onClick={onSpNavbarClose}
        className={`col-main ${navbarState.open ? 'body-with-overlay' : ''} ${
          chatState.open ? 'with-chat-sidebar' : ''
        }`}
      >
        <Outlet />
      </div>

      {/* AIチャットサイドバー */}
      <WsChatSidebar
        open={chatState.open}
        setOpen={open => setChatState(prev => ({ ...prev, open }))}
        messages={chatState.messages}
        setMessages={messages =>
          setChatState(prev => ({
            ...prev,
            messages: typeof messages === 'function' ? messages(prev.messages) : messages,
          }))
        }
        config={chatState.config}
      />

      {/* スマホでチャットサイドバーが開いている場合のオーバーレイ */}
      {chatState.open && (
        <div
          className="chat-sidebar-overlay d-md-none"
          onClick={() => setChatState(prev => ({ ...prev, open: false }))}
        />
      )}
    </main>
  );
}
